import { colors } from '../colors.js';
import { opacity } from '../opacity.js';
import { space } from '../spacing.js';
export const modalUnderlay = {
    backgroundColor: colors.backgrounds.dark,
    opacity: opacity.underlay,
    desktop: {
        paddingTop: space.x18,
        paddingBottom: space.x18,
        padding: space.x6,
    },
    tablet: {
        padding: space.x6,
    },
    mobile: {
        padding: space.x1,
    },
};
//# sourceMappingURL=modal-underlay.js.map